var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCommentAlt = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6 0h-19.2c-1.324 0.004-2.396 1.076-2.4 2.4v21.6l4.8-4.8h16.8c1.324-0.004 2.396-1.076 2.4-2.4v-14.4c-0.004-1.324-1.076-2.396-2.4-2.4h-0z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCommentAlt, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/comment-alt.5d9308c4.svg";
export { ForwardRef as ReactComponent };